<template>
  <v-row no-gutters class="relative" justify-md="space-around" justify="center">
    <!-- ProfileInformations -->
    <v-col class="pl-4" cols="12" :md="5" :sm="5" :lg="4">
      <TheAccountDisplayLoading
        v-if="isLoadingProfile"
        :style="profileClass"
        :class="
          `${
            !$vuetify.breakpoint.smAndUp
              ? 'mr-4'
              : 'sticky scroll--overflow-y thin-scrollbar'
          } `
        "
      ></TheAccountDisplayLoading>
      <TheAccountDisplay
        v-else
        :creator="onMyProfile ? myProfile : creator"
        :profileDisplayProp="profileDisplayProp"
        :onMyProfile="onMyProfile"
        :informationsAreEditable="
          onMyProfile && !toggleOptionToSeeMyPublicProfile
        "
        @toggleOptionToSeeMyPublicProfile="changeProfileVisibility()"
        @editPictureProfile="editPictureProfile"
        @editing="editing"
        :class="
          `${
            !$vuetify.breakpoint.smAndUp
              ? 'mr-4'
              : 'sticky scroll--overflow-y thin-scrollbar'
          } `
        "
        :style="profileClass"
      ></TheAccountDisplay>
    </v-col>
    <!-- TheSearch -->
    <v-col :cols="12" :md="7" :sm="7" :lg="8">
      <TheSearch
        v-if="
          (onMyProfile && myProfile.user.username.length) ||
            $route.name == 'profile'
        "
        :username="onMyProfile ? myProfile.user.username : this.username"
        :responsiveColTheSearch="
          onMyProfile && !toggleOptionToSeeMyPublicProfile
            ? responsiveColTheSearchMyProfile
            : responsiveColTheSearchProfile
        "
        :theSearchResponsiveColDestination="theSearchResponsiveColDestination"
        :theSearchResponsiveColPost="theSearchResponsiveColPost"
        :destinationPageResponsiveColPost="destinationPageResponsiveColPost"
        :searchType="
          onMyProfile && !toggleOptionToSeeMyPublicProfile
            ? 'posts'
            : 'destinations'
        "
        ref="TheSearch"
        :postsAreEditable="onMyProfile && !toggleOptionToSeeMyPublicProfile"
        :key="onMyProfile"
      ></TheSearch>
    </v-col>
    <v-dialog v-model="profileDisplayProp.isEditingPictureProfile" width="450">
      <AccountEditPictureModal
        v-if="profileDisplayProp.isEditingPictureProfile"
        @closeEditProfilePicture="closeEditProfilePicture"
        @triggerNewSearch="triggerNewSearch"
      ></AccountEditPictureModal>
    </v-dialog>
    <v-dialog v-model="profileDisplayProp.isEditingProfile" width="450">
      <AccountEditInformationModal
        v-if="!isLoadingProfile && profileDisplayProp.isEditingProfile"
        @closeEditProfileInformation="closeEditProfileInformation"
        @triggerNewSearch="triggerNewSearch"
      ></AccountEditInformationModal>
    </v-dialog>
  </v-row>
</template>
<script>
// CLASSES
import Creator from "../account/classes/Creator";
// SERVICE
// API
import CreatorAPI from "../account/apis/CreatorAPI";
// COMPONENTS
import AccountEditInformationModal from "../account/components/AccountEditInformationModal";
import AccountEditPictureModal from "../account/components/AccountEditPictureModal";
import TheAccountDisplay from "../account/components/TheAccountDisplay";
import TheAccountDisplayLoading from "../account/components/TheAccountDisplayLoading";
import TheSearch from "../search/components/TheSearch";
import { mapState } from "vuex";

export default {
  components: {
    AccountEditInformationModal,
    AccountEditPictureModal,
    TheAccountDisplay,
    TheAccountDisplayLoading,
    TheSearch
  },
  data() {
    return {
      username: "",
      creator: new Creator(),
      isLoadingProfile: true,
      profileDisplayProp: {
        isEditingProfile: false,
        isEditingPictureProfile: false
      },
      toggleOptionToSeeMyPublicProfile: false,
      responsiveColTheSearchProfile: {
        posts: {
          lg: 5,
          md: 12,
          sm: 12
        },
        map: {
          lg: 7,
          md: 12,
          sm: 12
        }
      },
      responsiveColTheSearchMyProfile: {
        posts: {
          lg: 12,
          md: 12,
          sm: 12
        },
        map: {
          lg: 7,
          md: 12,
          sm: 12
        }
      }
    };
  },
  watch: {
    shareStateKey() {
      this.$refs.TheSearch.newSearch();
    },
    toggleOptionToSeeMyPublicProfile() {
      this.$refs.TheSearch.newSearch();
    }
  },
  computed: {
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    myProfile() {
      return this.$store.getters.creator;
    },
    ...mapState({
      shareStateKey: state => state.shareStateKey
    }),
    profileClass() {
      if (this.$vuetify.breakpoint.lgAndUp)
        return `top: 80px; max-height: calc(100vh - 64px - 32px)`;
      if (this.$vuetify.breakpoint.smAndUp) {
        return `top: 72px; max-height: calc(100vh - 64px - 24px)`;
      }
      if (this.$vuetify.breakpoint.xs) return "margin-top:16px";
      return "";
    },
    onMyProfile() {
      return this.$route.params.username === this.myProfile.user.username;
    },
    theSearchResponsiveColDestination() {
      switch (this.$vuetify.breakpoint.name) {
        case "md":
          return "6";
        case "sm":
        case "xs":
        default:
          return "12";
      }
    },
    theSearchResponsiveColPost() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          return "3";
        case "lg":
          return "4";
        case "md":
          return "6"
        case "sm":
          return "12";
        case "xs":
        default:
          return "12";
      }
    },
    destinationPageResponsiveColPost() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          return "6";
        case "lg":
          return "12";
        case "md":
        case "sm":
          return "6";
        case "xs":
        default:
          return "12";
      }
    }
  },
  methods: {
    highlightLocation(locationApiId) {
      for (let index = 0; index < this.layers.locations.length; index++) {
        if (this.layers.locations[index].properties.apiId === locationApiId) {
          this.$refs.theMap.highlightLocation(this.layers.locations[index]);
          break;
        }
      }
    },
    unHighlightLocation(locationApiId) {
      for (let index = 0; index < this.layers.locations.length; index++) {
        if (this.layers.locations[index].properties.apiId === locationApiId) {
          this.$refs.theMap.unHighlightLocation(this.layers.locations[index]);
          break;
        }
      }
    },
    /* Events */
    stopLoadingMap() {
      this.loading.initMap = false;
    },
    editPictureProfile() {
      this.profileDisplayProp.isEditingPictureProfile = true;
    },
    editing() {
      this.profileDisplayProp.isEditingProfile = true;
    },
    closeEditProfileInformation() {
      this.profileDisplayProp.isEditingProfile = false;
    },
    closeEditProfilePicture() {
      this.profileDisplayProp.isEditingPictureProfile = false;
    },
    triggerNewSearch() {
      this.$refs.TheSearch.newSearch();
    },
    changeProfileVisibility() {
      this.toggleOptionToSeeMyPublicProfile = !this
        .toggleOptionToSeeMyPublicProfile;
      if (this.$route.query.hasOwnProperty("destinationId")) {
        this.$router.push({
          name: "profile",
          params: { username: this.myProfile.user.username }
        });
      }
    }
  },

  created() {
    if (this.onMyProfile) {
      this.isLoadingProfile = false;
    } else {
      /* Get Creator Information */
      this.username = this.$route.params.username;
      CreatorAPI.getCreatorProfileAPI(this.username)
        .then(response => {
          this.creator = new Creator(response.data);
          this.isLoadingProfile = false;
        })
        .catch(() => {});
    }
  }
};
</script>
